import styled, {css, keyframes} from "styled-components"

import {FIXED_HEIGHT_WRAPPER_TROPHY_SELECTED, FIXED_HEIGHT_WRAPPER_TROPHY_NOT_SELECTED} from "../constants"

interface StyledProps {
  isTrophySelected: boolean
  error: boolean
}

const Wrapper = styled.div<StyledProps>`
  box-shadow: 0 0 0 1px ${({error, theme}) => (error ? theme.colors.tertiary.r_400 : "rgba(61,61,54,0.25)")};
  margin-top: ${({theme}) => theme.spacing.one};
  margin-bottom: ${({theme, error}) => (error ? theme.spacing.two : "0")};
  border-radius: 2px;
  height: ${({isTrophySelected}) => (isTrophySelected ? FIXED_HEIGHT_WRAPPER_TROPHY_SELECTED : FIXED_HEIGHT_WRAPPER_TROPHY_NOT_SELECTED)};
  width: 100%;
  ${({isTrophySelected}) =>
    isTrophySelected &&
    css`
      animation: ${keyframes`
      0% {
        overflow: hidden;
      }
      100% {
        overflow: visible;
      }
    `} 1.2s ease;
    `}
`

export default Wrapper
